export default "__VITE_ASSET__4cceb2c4__"